import React from 'react';
import { GiftIcon } from 'lucide-react';
import { problemCards } from '../data/content';
import { bonuses, volumes } from '../data/volumes';
import { HeroSection } from '../components/HeroSection';
import { ProblemCard } from '../components/ProblemCard';
import { ProductIntro } from '../components/ProductIntro';
import { VolumeCard } from '../components/VolumeCard';
import { BonusCard } from '../components/BonusCard';
import { BenefitsGrid } from '../components/BenefitsGrid';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQAccordion } from '../components/FAQAccordion';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
import { CtaButton } from '../components/CtaButton';
type LandingPageProps = {
  guaranteeEnabled: boolean;
  testimonialsEnabled: boolean;
  bonusReferencePricesEnabled: boolean;
  salesPopupEnabled: boolean;
};
export function LandingPage({
  guaranteeEnabled,
  testimonialsEnabled,
  bonusReferencePricesEnabled,
  salesPopupEnabled
}: LandingPageProps) {
  return <div className="min-h-screen w-full bg-slate-100 font-sans text-slate-600" data-id="element-194" data-mp="3dabq1j4vd94g">
      <main className="mx-auto w-full max-w-3xl overflow-hidden bg-white" data-id="element-195" data-mp="3dcesj2n7kuq2">
        <HeroSection guaranteeEnabled={guaranteeEnabled} data-id="element-196" data-mp="3i8wrtmzrs0v0" />

        <section className="space-y-2.5 bg-slate-50 px-4 py-5 md:px-12" data-id="element-197" data-mp="3n7zy1arhkd4k">
          {problemCards.map(c => <ProblemCard key={c.title} {...c} data-id="element-198" data-mp="3r9uzcf9f2qic" />)}
          <div className="pt-3 text-center" data-id="element-199" data-mp="3r8a0wejzenf7">
            <p className="mx-auto mb-2.5 max-w-md text-sm font-bold leading-snug text-blue-950" data-id="element-200" data-mp="2qv1s4npidm">
              La próxima falla no te va a esperar. Tené los casos y las soluciones a mano antes de llegar al trabajo.
            </p>
            <CtaButton mode="scroll" subtext="4 tomos + 4 bonos • Acceso inmediato" data-id="element-201" data-mp="21vf0870v2fw1">
              Quiero diagnosticar sin improvisar
            </CtaButton>
          </div>
        </section>

        <ProductIntro data-id="element-202" data-mp="308kdcuffrzf5" />

        <section className="bg-slate-50 px-4 py-7 md:px-12" data-id="element-203" data-mp="309c7s1xarr3u">
          <h2 className="text-center text-2xl font-extrabold uppercase leading-tight tracking-tight text-blue-950 md:text-3xl" data-id="element-204" data-mp="3e7k1m0z1ecas">
            ¿Qué está incluido?
          </h2>
          <div className="mt-4 space-y-3" data-id="element-205" data-mp="3o452qb7xr39c">
            {volumes.map(v => <VolumeCard key={v.number} label={`Tomo ${v.number}`} title={v.title} subtitle={v.subtitle} intro={v.intro} listLabel={v.listLabel} items={v.items} outro={v.outro} finalLine={v.finalLine} data-id="element-206" data-mp="3j63k1ref95ye" />)}
          </div>
        </section>

        <section className="bg-blue-950 px-4 py-7 md:px-12" data-id="element-207" data-mp="5rh1cga97pwh">
          <h2 className="flex items-center justify-center gap-2 text-center text-xl font-extrabold uppercase leading-tight tracking-tight text-amber-400 md:text-3xl" data-id="element-208" data-mp="5oumdvl1a848">
            <GiftIcon className="h-6 w-6 shrink-0 md:h-8 md:w-8" strokeWidth={2.5} aria-hidden data-id="element-209" data-mp="uaiuxh3yqiy5" />
            Además, recibí 4 bonos profesionales
          </h2>
          <p className="mx-auto mt-1.5 max-w-lg text-center text-sm leading-snug text-slate-300" data-id="element-210" data-mp="kde6famnabe6">
            Herramientas complementarias para organizar y facilitar tu trabajo diario.
          </p>
          <div className="mt-4 space-y-2.5" data-id="element-211" data-mp="bcprmdpfg708">
            {bonuses.map(b => <BonusCard key={b.number} {...b} showReferencePrice={bonusReferencePricesEnabled} data-id="element-212" data-mp="3sthc5au75pzv" />)}
          </div>
        </section>

        <BenefitsGrid data-id="element-213" data-mp="1o7rzzsvw5y6" />
        <OfferSection showReferencePrices={bonusReferencePricesEnabled} guaranteeEnabled={guaranteeEnabled} data-id="element-214" data-mp="1nfx6r742c8y" />
        {guaranteeEnabled && <GuaranteeSection data-id="element-215" data-mp="3nud26hzg7o8h" />}
        {testimonialsEnabled && <TestimonialsSection data-id="element-216" data-mp="3nt34vv0f6k2w" />}
        <FAQAccordion data-id="element-217" data-mp="3nw7e56sqs60f" />
        <FinalCTA guaranteeEnabled={guaranteeEnabled} data-id="element-218" data-mp="3gqwsm2bicusu" />
        <Footer data-id="element-219" data-mp="3gqenshas589b" />
      </main>
      {salesPopupEnabled && <PurchasePopup data-id="element-220" data-mp="3brjxkuahghf6" />}
    </div>;
}